import {get} from 'lodash';
import Notifications from './notification.service';
import Events from './events.service';

const ErrorService = {
  async handle(error) {
    const code = get(error, 'response.status');
    const message = get(error, 'response.data.message');
    console.error(`ErrorService handler: ${code} ${message}`);
    console.error(error);
    if (message === 'GITHUB_APP_NOT_INSTALLED') {
      return Notifications.alert('This account requires you to install the <a href="https://github.com/apps/bionic-metrics">Bionic Metrics GitHub App</a>. Please install the GitHub App to proceed');
    }
    if (code === 401 || code === 403) {
      Notifications.toast('Please sign in again');
      Events.$emit('requestSignout');
    }
  }
};

export default ErrorService;
